import React from 'react';
import { Link } from 'react-router-dom';
import TableWrapper from '../../elements/TableWrapper';
import img from '../../../assets/img/At the office-pana 1.png';
import MiCompAPI from '../../../util/api';
import {
    Layout, message,  Row, Col,  Switch
} from 'antd';
const { Content } = Layout;
class Agencys extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [{
            title: 'Agency Name',
            dataIndex: 'agency_Name',
            render: (text, record) =>{ return <Link to={{ pathname: '/agencies/' + record["id"], state: { agency_id: record["id"] } }}>{text}</Link>},
            sorter: (a, b) => a.agency_Name.localeCompare(b.agency_Name),
            sortDirections: ["descend", "ascend"]
        }, {
            title: 'Primary Contact Name',
            dataIndex: 'primary_Contact_First_Name',
            render: (text, record) =>{ return record["primary_Contact_First_Name"]+" "+record["primary_Contact_Last_Name"]},
            sorter: (a, b) => a.primary_Contact_First_Name.localeCompare(b.primary_Contact_First_Name),
            sortDirections: ["descend", "ascend"]
        }, {
            title: 'Primary Contact Email',
            dataIndex: 'primary_Contact_Email',
            sorter: (a, b) => a.primary_Contact_Email.localeCompare(b.primary_Contact_Email),
            sortDirections: ["descend", "ascend"]
        }, {
            title: 'Primary Contact Phone',
            dataIndex: 'primary_Contact_Phone',
            render: (text, record) =>text&& text.length === 17 ? <a href={"tel:+" + text}>{ text}</a> : "Invalid US Number"
        },{
            title: 'Actions',
            dataIndex: '',
            render: (text, record) => {
                return (
                    <div style={{ display: 'flex' }}>



                        <Switch defaultChecked={record["isActive"]} style={{ marginRight: '10px' }} onChange={this.ChangeStatusOfAgency.bind(this, record["user_Id"])} />

                    </div>
                );
            }}];


        this.state = {
            allAgencysLoading: true
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    ChangeStatusOfAgency = (id) => {
        this.api.invoke("ChangeStatusOfUser/" + id, "patch", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                }
                else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.getAgencies();
            }
        });
    }

    componentDidMount() {

        this.getAgencies();
    }

    getAgencies = () => {
        this.api.invoke("BSU_GetAllAgencies", "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const Agencys = data.data;
                    this.data = Agencys;
                    this.setState({ allAgencysLoading: false });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
            else {
            }
        });
    }
    render() {
        return (
            <Content>
                 <div className="mi_main_div" style={{paddingLeft:"10px",paddingRight:"10px"}}>
                    <div className="mi_box">
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">Agencies</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <TableWrapper columns={this.columns} rowKey="id" data={this.state.allAgencysLoading ? null : this.data} loading={this.state.allAgencysLoading} title="All Agencies"  search={true} />
                </div>
            </Content>
        );
    }
}
export default Agencys;